import { Link } from 'react-router-dom';

export default function VisionCTA() {
  return (
    <section className="bg-white py-24 md:py-32 px-6 md:px-20">
      <div className="max-w-4xl mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">
          Vision – 「デジタル情報を信頼できる社会」と「暮らしのDX」
        </h2>

        {/* Content */}
        <div className="text-base md:text-lg leading-loose text-gray-700 mb-12 max-w-3xl mx-auto">
          <p className="mb-6">
            急速なデジタル化の一方で、情報改ざんやセキュリティリスクは年々高まっています。<br />
            私たちは、ブロックチェーンにより改ざん耐性の高いデータ基盤を構築し、<br />
            医療・決済・生活サービスなど、暮らしに直結する領域で「信頼できるデジタル社会」を実現します。
          </p>

          <p>
            同時に、AIを活用した対話型アプリやエージェント技術によって、<br />
            ・健康管理の負担軽減<br />
            ・行政・医療現場の業務効率化<br />
            ・高齢者を含む全世代が使いやすいサービス<br />
            を実現し、「人がより人らしく活躍できる社会づくり」に貢献していきます。
          </p>
        </div>

        {/* CTA Button */}
        <Link
          to="/vision"
          className="inline-flex items-center justify-center whitespace-nowrap px-12 py-4 bg-blue-900 text-white rounded-lg font-medium hover:bg-blue-800 hover:shadow-lg transition-all duration-300 cursor-pointer"
        >
          Our Visionを見る
        </Link>
      </div>
    </section>
  );
}
